<template>
    <div class="google-login-button mb-0 ">
        <g-signin-button
            class="btn btn-google"
            :params="googleSignInParams"
            @success="onSignInSuccess"
            @error="onSignInError"
        >
            <img src="/img/icons/google.svg" alt="Google">
            <span>{{ lang.labels.google|capitalize }}</span>
        </g-signin-button>
    </div>
</template>

<script>
import GSignInButton from 'vue-google-signin-button'
Vue.use(GSignInButton)

export default {
    data() {
        return {
            google_data: {},
            googleSignInParams: {
                client_id: process.env.MIX_GOOGLE_CLIENT_ID + '.apps.googleusercontent.com',
            },
        }
    },

    computed: {
        lang() {
            return this.$root.lang.login_form
        },
    },

    mounted() {
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://apis.google.com/js/platform.js?onload=renderButton')
        document.head.appendChild(recaptchaScript)
    },

    methods: {
        login() {
            isLoading()

            axios.post('/api/google-login', this.google_data)
                .then(({data}) => {
                    stopLoading()

                    this.$emit('signedin', data)
                })
                .catch(response => {
                    stopLoading()
                    
                    this.error = this.lang.errors.authentication
                })
        },

        onSignInSuccess (googleUser) {
            const profile = googleUser.getBasicProfile()

            this.google_data = {
                token: googleUser.getAuthResponse().id_token,
                first_name: profile.getGivenName(),
                last_name: profile.getFamilyName(),
                email: profile.getEmail(),
            }

            // console.log(this.google_data)

            this.login()
        },

        onSignInError (error) {
            // console.log('OH NOES', error)
        },
    },
}
</script>